export default {
    appTitle: "Kuusakoski Mobisulo",

    common: {
        cancel: "Cancel",
        close: "Close",
        confirm: "Confirm",
        next: "Next",
        save: "Save",
        search: "Search",
        send: "Send",
        error: "Error",
    },

    errorDialog: {
        body: "An error occured.",
        title: "Error"
    },

    navigation: {
        mainView: "Main view",
        support: "Support",
        termsOfUse: "Terms of use",
        dataPrivacy: "Data privacy",
        account: "Account",
        logOut: "Log out",
    },

    accountView: {
        email: "E-mail",
    },

    addressCard: {
        accessHoursAlways: "Open 24h",
        navigate: "Navigate"
    },

    deviationDialog: {
        addDeviation: "Submit report",
        removeTask: "Remove task",
        deviationCategory: "Category",
        deviationDescription: "Content",
        saveDeviation: "Save report",
        plannedQuantity: "Planned quantity",
        loadedQuantity: "Loaded quantity",
        remainingQuantity: "Material remaining",
        quantityUnit: "Unit",
        fileOptional: "File (optional)",
        waitingTime: "Waiting time",
        workTime: "Work time",
        loadTransportPartsInfo: "Add the cost of the failed task to these parts. Be sure to include these costs to the final load part data.",
        reportHoursInfo: "Add the cost of the hour work to these parts. Be sure to include these costs to the final load part data."
    },

    findUnitDialog: {
        findUnit: "Find unit",
        unitNumber: "Unit number",
    },

    loadExecutionDialog: {
        loadExecutionInfo: "Load execution info",
        comment: "Comment",
        commentPlaceholder: "If you can't enter the execution information to the fields above, enter it here."
    },

    loadTransportPartEdit: {
        otherValue: "Other value",
    },

    loadTaskSelect: {
        noLoads: "No loads.",
        selectTask: "Select task",
        transition: "Transition",
    },

    login: {
        authenticationResponse: {
            Error: "Incorrect e-mail or password",
            Unsupported: "The user has to log in via Kuusakoski main www site"
        },

        logIn: "Log in",
    },

    mainView: {
        incompleteTasksInstructions: "The vehicle has old tasks or loads that haven't been completed. Date selection was changed automatically.",
        date: "Date",
        vehicle: "Vehicle"
    },

    missingUnitDialog: {
        additionalFeatures: "Additional features",
        reportMissingUnit: "Report missing unit",
        instructions: "Unit wasn't found with the unit number you searched. Report a missing unit.",
        unitNumber: "Unit number",
        unitType: "Unit type",
        sideDoors: "Side doors",
        sideRelease: "Side release",
        securityChain: "Security chain",
    },

    planTaskDialog: {
        loads: "Loads",
        task: "Task",
        planTask: "Plan task",
        createNewLoad: "Create new load",
        newLoad: "New load",
        addToLoad: "Add to load",
        removeFromLoad: "Remove from load",
    },

    planTaskDistanceDialog: {
        distance: "Distance",
        end: "To",
        endInput: "To (city/postal code)",
        noResults: "No results",
        notes: "Notes",
        start: "From",
        startInput: "From (city/postal code)",
        title: "Distance search"
    },

    planTaskLoadTransportPartsDialog: {
        transportParts: "Transport parts",
    },

    taskStartedDialog: {
        selectTaskType: "Select task type",
        startTask: "Start task",
    },

    taskTransportingDialog: {
        taskTypeTitle: "Task type",
        leaveUnitsTitle: "Dropped off units",
        noLeaveUnits: "No unit drop-off.",
        takeUnitsTitle: "Picked up units",
        noTakeUnits: "No unit pick-up.",
        findUnit: "Find unit",
        unitsMustBeProcessedBeforeAdvancing: "Units must be defined before proceeding to the next phase!",
        externalUnit: "External unit",
        confirmIgnoringUnitProcessing: "Confirm that unit processing is ignored.",
        confirmWaybill: "Confirm movement document",
        editWaybill: "Edit movement document",
    },

    taskDirection: {
        Deliver: "Deliver",
        Exchange: "Exchange",
        Retrieve: "Retrieve",
    },

    taskState: {
        New: "New",
        Planned: "Planned",
        Started: "Started",
        Transporting: "Transporting",
        Ready: "Ready",
        Deferred: "Deferred",
    },

    taskView: {
        addressFrom: "From",
        addressTo: "To",
        tasks: "Tasks",
        transportReference: "Order reference",
        noReference: "No reference",
        deviations: "Reports",
        extraOrder: "eService order",
        attachments: "Attachments",
        noAttachments: "No attachments",
        taskStarted: "Start",
        taskTransporting: "Leave from customer",
        taskReady: "Ready",
        executionInfo: "Execution info",
        waybill: "Movement document",
        revertTask: "Revert to planned",
        addDeviation: "Submit report",
        removeTask: "Remove task",
        planTask: "Plan task",
        units: "Units",
        driversActions: "Driver's actions",
        taskType: "Task type",
        id: "Id",
        type: "Type",
        direction: "Direction",
        newLocation: "New location",
        contactPhone: "Phone number of the person who made the order",
        onsitePhone: "Phone number of the location's contact person",
        orderDetails: "Order details",
    },

    termsView: {
        acceptTerms: "Accept terms of use",
        termsAcceptedOn: "Terms of use accepted on",
    },

    transportPartType: {
        KM: "km",
        PCS: "pcs",
        TIME: "Time",
        TN: "tn",
        TRANSITION: "Transition"
    },

    unitSelect: {
        noUnitsAtParty: "There are no units at this location.",
        showAllNUnits: "Show all {0} units",
    },

    validationErrors: {
        required: "Required",
    },

    vehicleCalendar: {
        selectDate: "Select date"
    },

    vehicleSelectDialog: {
        selectVehicle: "Select vehicle",
        registerNumber: "Register number",
        company: "Company",
    },

    waybill: {
        packagingType: "Packaging type",
        quantity: "Quantity",
    },

    weekdays: {
        "0": "mon",
        "1": "tue",
        "2": "wed",
        "3": "thu",
        "4": "fri",
        "5": "sat",
        "6": "sun",
    }
};
